export enum TOKEN_NOTICE_TYPES {
  ADD = 'add',
  SELECT = 'select',
  ZERO_BALANCE = 'zeroBalance',
  ZERO_LIMIT = 'zeroLimit',
  SHARE_TOO_BIG = 'shareTooBig',
  SHARE_TOO_SMALL = 'shareTooSmall',
  NOT_AVAILABLE = 'notAvailable',
}
